module.exports = __webpack_public_path__ + "img/lock.cf87f3d1.jpg";